export enum DialogType {
  Default = 'default',
}
